import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Inventory.css";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import { components } from "react-select";
import { IoIosSearch } from "react-icons/io";

export const SubEditRefWiseStock = () => {
  const location = useLocation();
  const { Id } = location.state || "";
  console.log("Id", Id);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [refNo, setRefNo] = useState();
  const [receivedData, setReceivedData] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [dropdownProductcode, setDropdownProductCode] = useState();

  // search icon in product code
  const SearchDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <IoIosSearch size={16} color="#92959c" />
      </components.DropdownIndicator>
    );
  };

  const [addStockRow, setAddStockRow] = useState([
    {
      id: Date.now() + Math.random(),
      productCode: "",
      productId: "",
      product: "",
      category: "",
      existingStock: "",
      // sellingPrice: "",
      defaultPrice: "",
      qty: "",
      total: "",
    },
  ]);
  // Add stock  new row
  const handleAddStockRow = () => {
    setAddStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now() + Math.random(), //it creates a unique ID based on the exact millisecond the row was added.
        productCode: "",
        productId: "",
        product: "",
        category: "",
        existingStock: "",
        // sellingPrice: "",
        defaultPrice: "",
        qty: "",
        total: "",
      },
    ]);
  };
  console.log("addStockRow", addStockRow);
  const totalQty = addStockRow.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0,
  );
  const totalValue = addStockRow.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0,
  );
  // Delete add stock row
  const handleDeleteStockRow = (id) => {
    setAddStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };
  function handleQtyChange(rowId, value) {
    const qty = Number(value);

    setAddStockRow((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId //only update the matching row here  both row.id===rowId is from frontend
          ? {
              ...row,
              qty: qty,
              total: qty * Number(row.defaultPrice || 0),
            }
          : row,
      ),
    );
  }
  async function fetchProductDetails(rowId, productId, productCode) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/inventory/subdistributor/product/${productId}`,
      );
      if (response.data.status === "success" || response.status === 200) {
        const details = response.data.data;

        setAddStockRow((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId // only update the matching row here  both row.id===rowId is from frontend
              ? {
                  ...row,
                  // backendId: details.id,
                  productId: productId,
                  productCode: productCode,

                  product: details.product_name ?? "---",
                  category: details.category ?? "---",
                  existingStock: details.exisiting_stock ?? "---",
                  // sellingPrice: details.subdistributor_selling_price || "",
                  defaultPrice: details.default_cost_price ?? "---",
                  qty: row.qty || 1,
                  total: (row.qty || 1) * details.default_cost_price,
                }
              : row,
          ),
        );
        console.log(
          response.data.message || "Product details fetched successfully",
        );
        // toast.success(
        //   response.data.message || "Product details fetched successfully"
        // );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details",
      );
    } finally {
      setLoading(false);
    }
  }
  // useEffect(() => {
  //   addStockRow.forEach((row) => {
  //     if (!row.productCode) {
  //       fetchProductDetails(row.id, "pc-01"); // auto-load first option
  //     }
  //   });
  // }, []);

  async function LoadDropdownProductcode() {
    try {
      const response = await axiosInstance.get(
        "/inventory/subdistributor/product-code/",
      );
      if (response.data.status === "success" || response.status === 200) {
        setDropdownProductCode(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load dropdown");
      console.log("Failed to load dropdown");
    }
  }
  const productCodeOptions = dropdownProductcode?.map((item) => ({
    // value: item.product_code,
    value: item.prod_id,
    label: item.product_code,
  }));
  useEffect(() => {
    LoadDropdownProductcode();
  }, []);
  async function handleSave() {
    try {
      setLoading(true);
      const existingItems = [];
      const newItems = [];

      addStockRow.forEach((item) => {
        const commonData = {
          qty: Number(item.qty || 0),
          unit_cost_price: item.defaultCost,
        };

        //  Existing row update
        if (item.itemId) {
          existingItems.push({
            item_id: item.itemId, // here we saved exist product id in itemId field
            ...commonData,
          });
        }
        // New row create
        else if (item.productId) {
          newItems.push({
            product_id: item.productId, // newly added id saved in productId field
            ...commonData,
          });
        }
      });
      const payload = {
        additional_notes: additionalNote,
        existing_items: existingItems,
        new_items: newItems,
      };
      const response = await axiosInstance.put(
        `/inventory/subdistributor/incoming-stock-update/${Id}/`,
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "submitted successfully");
        console.log("submitted successfully");
        setTimeout(() => {
          navigate("/sub-inventory");
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }

  // all products data to prefill table
  const [allProducts, setAllProducts] = useState({});
  async function fetchAllProductsData() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/inventory/distributor/incoming-stock-items/${Id}/`,
      );
      if (response.status === 200 || response.data.status === "Success") {
        setAllProducts(response.data.data);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to fetch all products data",
      );
      console.log("Failed to fetch all products data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (Id) {
      fetchAllProductsData();
    }
  }, [Id]);

  useEffect(() => {
    if (allProducts?.products?.length > 0) {
      // Prefill top fields
      setRefNo(allProducts.reference_no || "");
      setReceivedData(allProducts.received_date || "");
      setAdditionalNote(allProducts.additional_notes || "");

      // Prefill table rows
      const mappedRows = allProducts.products.map((item) => ({
        id: Date.now() + Math.random(),

        itemId: item.item_id,
        productId: item.product_id,
        productCode: item.product_code,

        product: item.product_name ?? "---",
        category: item.category ?? "---",
        existingStock: item.exisiting_stock ?? "---",
        defaultPrice: item.default_cost_price ?? "---",
        qty: item.qty ?? "---",
        total: item.total_cost ?? "---",
      }));

      setAddStockRow(mappedRows);
    }
  }, [allProducts]);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/sub-inventory" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Edit Incoming Stock</div>
          </div>

          {/* Reference No & Date */}
          <div className="bulkAddGrid">
            <div>
              <label>Reference No.</label>
              <input
                type="text"
                placeholder="Enter Reference No."
                value={refNo}
                onChange={(e) => setRefNo(e.target.value)}
                disabled
                style={{ cursor: "not-allowed" }}
              />
            </div>
            <div>
              <label>Received Date</label>
              <input
                type="date"
                onChange={(e) => setReceivedData(e.target.value)}
                value={receivedData}
                disabled
                style={{ cursor: "not-allowed" }}
              />
            </div>
          </div>

          {/* Table */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Product Code</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">Category</TableCell>
                    <TableCell align="left">Existing Stock</TableCell>
                    {/* <TableCell align="left">Selling Price</TableCell> */}
                    <TableCell align="left">
                      Default Cost Price / Unit
                    </TableCell>
                    <TableCell align="left">Qty</TableCell>

                    <TableCell align="left">Total Stock</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {addStockRow.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      className="dashboardTableBody"
                    >
                      {/* <TableCell align="left">
                        <select
                          className="addModalQtySelect"
                          value={row.productCode}
                          onChange={(e) => {
                            fetchProductDetails(row.id, e.target.value);
                          }}
                        >
                          <option value={""} selected disabled>
                            Select
                          </option>
                          {dropdownProductcode?.map((drop) => (
                            <option value={drop.product_code}>
                              {drop.product_code}
                            </option>
                          ))}
                        </select>
                      </TableCell> */}
                      <TableCell align="left" style={{ minWidth: "180px" }}>
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productCodeOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.productCode,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(
                              row.id,
                              selected?.value,
                              selected?.label,
                            )
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.product}
                            placeholder="Product"
                          />
                        </span> */}
                        {row.product ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        {row.category ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.existingStock}
                            placeholder="Existing Stock"
                          />
                        </span> */}
                        {row.existingStock ?? "---"}
                      </TableCell>
                      <TableCell align="left">
                        {row.defaultPrice ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.qty}
                            placeholder="Qty"
                            onChange={(e) =>
                              handleQtyChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.total}
                            placeholder="Total"
                          />
                        </span> */}
                        {row.total ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        <MdDeleteOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteStockRow(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Add Row Button */}
          <div
            className="addRowText"
            onClick={handleAddStockRow}
            style={{ cursor: "pointer", marginTop: "10px" }}
          >
            + Add Row
          </div>

          {/* Totals */}
          <div className="addModalTotalContainer">
            <div>
              {/* <div className="addModalContent">
                <span>Total Items:</span>
                <span>2</span>
              </div>
              <div className="addModalContent">
                <span>Total Products Received:</span>
                <span>2400 nos</span>
              </div> */}
              <div className="addModalContent">
                <span>Total Products Received(Qty):</span>
                <span>{totalQty} nos</span>
              </div>
              <div className="addModalContent">
                <span>Total Value:</span>
                <span>₹{totalValue.toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="bulkAddTextGrid">
            <div>
              <label>Additional Notes</label>
            </div>
            <div>
              <textarea
                placeholder="Type here"
                rows={4}
                value={additionalNote}
                onChange={(e) => setAdditionalNote(e.target.value)}
              ></textarea>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "10px" }}
            >
              {/* <button className="addBtnCancel">Cancel</button> */}
              <button className="addBtnSave" onClick={handleSave}>
                Save & Edit Stock
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
